export function updateMiniCart() {
    if (window.refreshMiniCartItems) {
        window.refreshMiniCartItems();
    }
}
